import { ref } from 'vue'
import { defineStore } from 'pinia'
import { v4 as uuidv4 } from 'uuid'
import type { NovoIconNames } from '@novonordisk/studyhub-novoui/vue'
import type { NotificationVariant } from '@/components/shared/VNotification.vue'

const interval: number = 3000

export type ApplicationToast = {
  id: string
  title?: string
  text?: string
  variant?: NotificationVariant
  icon?: NovoIconNames
}

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<ApplicationToast[]>([])
  const timeouts = ref<Map<string, ReturnType<typeof setTimeout>>>(new Map())

  function addToast(toast: Partial<Omit<ApplicationToast, 'id'>>) {
    const id = uuidv4()

    toasts.value.push({
      id,
      title: toast.title ?? undefined,
      text: toast.text ?? undefined,
      variant: toast.variant ?? 'true-blue',
      icon: toast.icon ?? undefined,
    })

    const timeout = setTimeout(() => {
      removeToast(id)
    }, interval)

    timeouts.value.set(id, timeout)
  }

  function removeToast(id: string) {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
    clearTimeout(timeouts.value.get(id))
  }

  return { toasts, removeToast, addToast }
})
